/**
 * 히어로 배경 — 은은하게 움직이는 뉴럴넷/노드 컨스텔레이션.
 * 결정적(고정) 좌표를 사용해 매 프레임 난수 없이 가볍게 동작하며,
 * 점멸/흐름 애니메이션은 SCSS(prefers-reduced-motion 시 정지).
 */

const NODES: Array<[number, number]> = [
  [120, 160],
  [320, 90],
  [480, 240],
  [250, 380],
  [120, 560],
  [430, 500],
  [620, 140],
  [700, 360],
  [560, 650],
  [840, 520],
  [980, 220],
  [1130, 380],
  [1290, 170],
  [1210, 600],
  [1350, 440],
  [930, 730],
];

const EDGES: Array<[number, number]> = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 4],
  [2, 5],
  [1, 6],
  [6, 7],
  [5, 7],
  [5, 8],
  [7, 9],
  [6, 10],
  [10, 11],
  [10, 12],
  [11, 13],
  [13, 14],
  [9, 8],
  [8, 15],
  [13, 9],
];

const COLORS = ['#2ad6e6', '#9a7bff', '#e0455a'];

export default function HeroBackground() {
  return (
    <svg
      className="ai-hero__bg"
      viewBox="0 0 1440 820"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden
      focusable="false"
    >
      <g opacity={0.5}>
        {EDGES.map(([a, b], i) => {
          const [x1, y1] = NODES[a];
          const [x2, y2] = NODES[b];
          const color = COLORS[i % COLORS.length];
          return (
            <g key={i}>
              <line className="ai-flow-base" x1={x1} y1={y1} x2={x2} y2={y2} opacity={0.5} />
              <line
                className={`ai-flow-line ${i % 2 ? 'is-rev' : ''} is-slow`}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke={color}
                opacity={0.55}
                style={{ animationDelay: `${(i % 5) * 0.4}s` }}
              />
            </g>
          );
        })}
        {NODES.map(([x, y], i) => (
          <circle
            key={i}
            className="ai-graph-node"
            cx={x}
            cy={y}
            r={i % 3 === 0 ? 6 : 4}
            stroke={COLORS[i % COLORS.length]}
            style={{ animationDelay: `${(i % 6) * 0.5}s` }}
          />
        ))}
      </g>
    </svg>
  );
}
